import React from 'react';
import c from 'classnames';
import SolidButton, { SolidButtonProps } from '../../../../../Buttons/SolidButton';

import s from './LargeInputFieldButton.scss';

/**
 * Our SolidButtonProps with a few unnecessary props removed.
 */
export interface RestrictedButtonProps extends Omit<
  SolidButtonProps,
  'className' | 'size' | 'variant'
> {
  variant?: SolidButtonProps['variant'];
}

export interface Props extends RestrictedButtonProps {
  isPostfix?: boolean;
}

const LargeInputFieldButton: React.FC<Props> = ({
  // "approval-green" seems a sensible default going by the spec, so including it for a little boost in dev ux
  variant = 'approval-green',
  isPostfix,
  ...rest
}) => {
  return (
    <SolidButton
      size="large"
      className={c(isPostfix && s['postfix'])}
      variant={variant}
      {...rest}
    />
  );
};

LargeInputFieldButton.displayName = 'LargeInputFieldButton';

export default LargeInputFieldButton;
